var React = require('react');

function CheckRound (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"34","cy":"34","r":"34","fill":"#F4DB8D","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M30.4545 42.3582L21.8636 33.8955L19 36.7164L30.4545 48L55 23.8209L52.1364 21L30.4545 42.3582Z","fill":"#2D0469","key":1})]);
}

CheckRound.defaultProps = {"width":"68","height":"68","viewBox":"0 0 68 68","fill":"none"};

module.exports = CheckRound;

CheckRound.default = CheckRound;
